module.exports = __webpack_public_path__ + "img/whats-new-13_enBU.8eb3e9f.jpg";